import resources from "virtual:i18next-loader"
import i18next, { type i18n } from "i18next"
import { initReactI18next } from "react-i18next"

export type Locale = "en-US"

export class Localisation {
  public readonly instance: i18n

  private constructor(instance: i18n) {
    this.instance = instance
  }

  public static init(locale: Locale): Localisation {
    const instance = i18next.createInstance({
      lng: locale,
      ns: ["main"],
      defaultNS: "main",
      fallbackLng: "en-US",
      resources,
      interpolation: {
        escapeValue: false,
      },
    })

    instance.use(initReactI18next).init()

    return new Localisation(instance)
  }
}
